const WORDS = [
  'lorem', 'ipsum', 'dolor', 'sentar', 'consertar', 'adição', 'elite',
  'sed', 'fazer', 'eiusmod', 'tempor', 'incidente', 'ut', 'trabalho',
  'e', 'dor', 'magna', 'aliqua', 'ao', 'enim', 'ad', 'mínimo', 'veniam',
  'quis', 'nostrud', 'exercício', 'ullamco', 'laboris', 'nisi', 'aliquipe',
  'ex', 'ea', 'comodo', 'consequência', 'duis', 'aute', 'irure', 'em',
  'reprender', 'em', 'voluptar', 'velar', 'esse', 'cilio', 'dolori',
  'eu', 'fugia', 'nula', 'pariatur', 'excepto', 'sinto', 'ocaso',
  'cupidatate', 'não', 'proidente', 'sunto', 'em', 'culpa', 'que',
  'ofício', 'deserunte', 'molite', 'animo', 'ide', 'está', 'laboro',
]

const randomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min

const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1)

const buildSentence = () => {
  const length = randomInt(6, 14)
  const words = Array.from(
    { length },
    () => WORDS[randomInt(0, WORDS.length - 1)],
  )
  return `${capitalize(words[0])} ${words.slice(1).join(' ')}.`
}

const buildParagraph = () => {
  const sentenceCount = randomInt(4, 7)
  return Array.from({ length: sentenceCount }, buildSentence).join(' ')
}

export const generateLoremIpsum = (unit, count) => {
  if (unit === 'words') {
    return Array.from(
      { length: count },
      () => WORDS[randomInt(0, WORDS.length - 1)],
    ).join(' ')
  }
  if (unit === 'sentences') {
    return Array.from({ length: count }, buildSentence).join(' ')
  }
  return Array.from({ length: count }, buildParagraph).join('\n\n')
}
